import { render, staticRenderFns } from "./RedirectionPageOTP.vue?vue&type=template&id=4ba267ac&"
import script from "./RedirectionPageOTP.vue?vue&type=script&lang=js&"
export * from "./RedirectionPageOTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports